export const PROGRAM_CATEGORIES = `
  query programCategories($filter: FilterProgramCategoryInput, $tenant_id: Int!) {
    programCategories(filter: $filter, tenant_id: $tenant_id) {
      id
      name
      include
      link
      pro_bono
      color
      usa_program_id
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
    }
  }
`;
